import * as PIXI from "pixi.js";
import { rootEventBus, EnumRootEventBus } from "../managers/RootEventBus";
import { cursorEventBus, EnumCursorEventBus } from "../entities/UI/CustomCursor/CustomCursorEventBus";
import { CustomCursorType } from "../entities/UI/CustomCursor/CustomCursor";
import getCleanCoord from "./coord/getCleanCoord";
import { brightnessFilter } from "../filters";


export default function addInteractivity(
  elm: PIXI.Container | PIXI.Sprite | PIXI.Graphics,
  eventFuncs: {
    handleOverFunc?: (e: PIXI.FederatedPointerEvent) => void,
    handleDownFunc?: (e: PIXI.FederatedPointerEvent) => void,
    handleMoveFunc?: (e: PIXI.FederatedPointerEvent) => void,
    handleUpFunc?: (e: PIXI.FederatedPointerEvent) => void,
    handleLeaveFunc?: (e: PIXI.FederatedPointerEvent) => void
    handleOutFunc?: (e: PIXI.FederatedPointerEvent) => void,
    handleUpOutSideFunc?: (e: PIXI.FederatedPointerEvent) => void,
  },
  cursorType: CustomCursorType,
  isCursorMutable: boolean = false,
  isButton: boolean = false
) {
  const { handleOverFunc, handleDownFunc, handleMoveFunc, handleUpFunc, handleLeaveFunc, handleOutFunc, handleUpOutSideFunc } = eventFuncs;
  const handleDown = (e: PIXI.FederatedPointerEvent) => {
    rootEventBus.emit(EnumRootEventBus.setInteractLayer, true);
    isButton && elm.scale.set(.95);
    !isCursorMutable && cursorEventBus.emit(EnumCursorEventBus.setInteractLayerCursor, cursorType);
    handleDownFunc && handleDownFunc(e);
  }
  const handleUp = (e: PIXI.FederatedPointerEvent) => {
    rootEventBus.emit(EnumRootEventBus.setInteractLayer, false);
    isButton && elm.scale.set(1);
    !isCursorMutable && cursorEventBus.emit(EnumCursorEventBus.setInteractLayerCursor, CustomCursorType.default);
    handleUpFunc && handleUpFunc(e);
  }
  const handleLeave = (e: PIXI.FederatedPointerEvent) => {
    handleLeaveFunc && handleLeaveFunc(e);
  }
  const handleOver = (e: PIXI.FederatedPointerEvent) => {
    const coord = getCleanCoord(e.global);
    cursorEventBus.emit(EnumCursorEventBus.setCursor, cursorType, coord);
    elm.filters = [brightnessFilter];
    handleOverFunc && handleOverFunc(e);
  }
  const handleMove = (e: PIXI.FederatedPointerEvent) => {
    const coord = getCleanCoord(e.global);
    cursorEventBus.emit(EnumCursorEventBus.setCursor, cursorType, coord, isCursorMutable);
    handleMoveFunc && handleMoveFunc(e);
  }
  const handleOut = (e: PIXI.FederatedPointerEvent) => {
    cursorEventBus.emit(EnumCursorEventBus.setCursor, CustomCursorType.empty);
    isButton && elm.scale.set(1);
    elm.filters = [];
    handleOutFunc && handleOutFunc(e)
  };
  const handleOutSide = (e: PIXI.FederatedPointerEvent) => handleUpOutSideFunc && handleUpOutSideFunc(e);

  elm.interactive = true;
  elm.cursor = "none";
  elm
    .on("pointerover", handleOver)
    .on("pointermove", handleMove)
    .on("pointerout", handleOut)
    .on("pointerupoutside", handleOutSide)
    .on("pointerdown", handleDown)
    .on("pointerup", handleUp)
    .on("pointerupoutside", handleUp)
    .on("pointerleave", handleLeave)
}